export default __webpack_public_path__ + "static/media/Class_Code.656803f4.svg";